import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { iban, WebTagPermissionEnum } from '@/Shared/domain'
import { navigationRoutes } from '@/Shared/ui/routers'
import { useWebTagPermissions } from '@/User/context/WebTagPermissionsProvider'
import { useUserData } from '@/User/ui/context'

interface ChangeBankAccountAccessCardProps {
  origin: string
  largeVersion?: boolean
}

export const ChangeBankAccountAccessCard = ({
  origin,
  largeVersion = false,
}: ChangeBankAccountAccessCardProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { hasPermission } = useWebTagPermissions()
  const { currentIban } = useBankAccount()
  const { merchant } = useUserData()
  return (
    <OreCardContainer>
      <OreCardWrapper>
        <OreStack placeContent="stretch" space="small">
          <OreHeading as="h2" size="headline-md">
            {t(contractTranslation.changeBankAccount.accessCard.title)}
          </OreHeading>

          <OreDivider />

          <OreStack
            placeContent="space-between"
            direction={largeVersion ? 'row' : 'column'}
          >
            <OreStack placeContent="start" space="xsmall">
              <OreStack
                placeContent="start"
                placeItems="center"
                space="2xsmall"
                direction="row"
              >
                <OreText bold>
                  {t(contractTranslation.changeBankAccount.accessCard.iban.label)}
                </OreText>
              </OreStack>
              <OreText>{currentIban.includes("*") ? currentIban : iban(currentIban)}</OreText>
            </OreStack>
              <OreStack placeContent="start" space="small">
                {merchant.isNursery && 
                  origin === navigationRoutes.home && 
                  (!hasPermission(WebTagPermissionEnum.ACTION_BANK_ACCOUNT_CHANGE) 
                      || !hasPermission(WebTagPermissionEnum.ACTION_BILLING_DATA_CHANGE)) ? (
                  <OreButton
                    data-testid="changeBankAccount"
                    category="secondary"
                    onClick={() =>
                      navigate(navigationRoutes.contractsBillingData, {
                        state: { origin: origin },
                      })
                    }
                  >
                    {t(contractTranslation.changeBankAccount.accessCard.button.billingData)}
                  </OreButton>
                ):
                  <OreButton
                    data-testid="changeBankAccount"
                    disabled={!hasPermission(WebTagPermissionEnum.ACTION_BANK_ACCOUNT_CHANGE) 
                      || !hasPermission(WebTagPermissionEnum.ACTION_BILLING_DATA_CHANGE) }
                    category="secondary"
                    onClick={() =>
                      navigate(navigationRoutes.changeBankAccount, {
                        state: { origin: origin },
                      })
                    }
                  >
                    {t(contractTranslation.changeBankAccount.accessCard.button.label)}
                  </OreButton>
                }
              </OreStack>
          </OreStack>
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
